// project imports
import config from 'config';

// action - state management
import * as actionTypes from './actions';

export const initialState = {
    isOpen: [], // for active default menu
    fontFamily: config.fontFamily,
    borderRadius: config.borderRadius,
    opened: true,
    toastStatus: false,
    toastObject: { status: false },
    loading: false,
    activePage: null,
    userData: {},
    userProfile: '',
    companyData: {},
    companyProfile: '',
    unreadQuestions: 0,
    modalStatus: false,
    firstTimeLogin: false,
    modalType: null,
    teamMembers: {},
    eventDate: new Date(),
    error: false,
    onBoardingLoading: false,
    switchedCompany: false,
    companyProfileLoading: true,
    isOpenConfirmationModalLock: false,
    isInputChangesForLock: false,
    isNewToken: false,
    isReloadCalendar: false,
    isFromAddEditAndDelete: false,
    selectedNavItem: null,
    authorizedEmails: [],
    navReload: false
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const customizationReducer = (state = initialState, action) => {
    let id;
    switch (action.type) {
        case actionTypes.SET_AUTHORIZED_USERS:
            return {
                ...state,
                authorizedEmails: action.authorizedEmails
            };
        case actionTypes.SET_SELECTED_NAV_ITEM:
            return {
                ...state,
                selectedNavItem: action?.selectedItem ?? null
            };

        case actionTypes.MENU_OPEN:
            id = action.id;
            return {
                ...state,
                isOpen: [id]
            };
        case actionTypes.SET_MENU:
            return {
                ...state,
                opened: action.opened
            };
        case actionTypes.SET_FONT_FAMILY:
            return {
                ...state,
                fontFamily: action.fontFamily
            };
        case actionTypes.SET_BORDER_RADIUS:
            return {
                ...state,
                borderRadius: action.borderRadius
            };
        case actionTypes.SET_TOAST_STATUS:
            return {
                ...state,
                toastStatus: action.toastStatus
            };
        case actionTypes.SET_TOAST_OBJECT:
            return {
                ...state,
                toastObject: action.toastObject
            };
        case actionTypes.SET_LOADING:
            return {
                ...state,
                loading: action.loading
            };
        case actionTypes.SET_ACTIVE_PAGE:
            return {
                ...state,
                activePage: action.activePage
            };
        case actionTypes.SET_USER_DATA:
            return {
                ...state,
                userData: action.userData
            };
        case actionTypes.SET_USER_PROFILE:
            return {
                ...state,
                userProfile: action.userProfile
            };
        case actionTypes.SET_COMPANY_DATA:
            return {
                ...state,
                companyData: action.companyData
            };
        case actionTypes.SET_COMPANY_PROFILE:
            return {
                ...state,
                companyProfile: action.companyProfile
            };
        case actionTypes.SET_COMPANY_PROFILE_IS_UPDATING:
            return {
                ...state,
                companyProfileLoading: action.companyProfileLoading
            };
        case actionTypes.SET_UNREAD_QUESTIONS:
            return {
                ...state,
                unreadQuestions: action.unreadQuestions
            };
        case actionTypes.SET_MODAL_STATUS:
            return {
                ...state,
                modalStatus: action.modalStatus
            };
        case actionTypes.SET_MODAL_TYPE:
            return {
                ...state,
                modalType: action.modalType
            };
        case actionTypes.SET_TEAM_MEMBERS:
            return {
                ...state,
                teamMembers: action.teamMembers
            };
        case actionTypes.SET_EVENTS:
            return {
                ...state,
                events: action.events
            };
        case actionTypes.SET_EVENT_DATE:
            return {
                ...state,
                eventDate: action.eventDate
            };
        case actionTypes.SET_ONBOARDING_DATA:
            return {
                ...state,
                onBoardingData: action?.onBoardingData
            };
        case actionTypes.NOT_SET_ONBOARDING_DATA:
            return {
                ...state,
                error: action.error
            };
        case actionTypes.LOADING_ONBOARDING_DATA:
            return {
                ...state,
                onBoardingLoading: action.onBoardingLoading
            };
        case actionTypes.SWITCHED_COMPANY:
            return {
                ...state,
                switchedCompany: action.switchedCompany
            };
        case actionTypes.CLEAR_DATA:
            return {
                ...state,
                userData: {},
                userProfile: '',
                companyData: {},
                companyProfile: '',
                firstTimeLogin: false
            };
        case actionTypes.SET_FIRST_TIME_LOGIN:
            return {
                ...state,
                firstTimeLogin: action.firstTimeLogin
            };
        case actionTypes.SET_CONFIRMATION_MODAL_OPEN_FOR_LOCK:
            return {
                ...state,
                isOpenConfirmationModalLock: action.isOpenConfirmationModalLock
            };
        case actionTypes.SET_INPUT_CHANGES_FOR_LOCK:
            return {
                ...state,
                isInputChangesForLock: action.isInputChangesForLock
            };
        case actionTypes.SET_NEW_TOKEN:
            return {
                ...state,
                isNewToken: action.isNewToken
            };
        case actionTypes.SET_CALENDAR_SECTION_LOADING:
            return {
                ...state,
                isReloadCalendar: action.isReloadCalendar
            };
        case actionTypes.SET_IS_CALENDAR_FROM_EDIT_ADD_AND_DELETE:
            return {
                ...state,
                isFromAddEditAndDelete: action.isFromAddEditAndDelete
            };
        case actionTypes.SET_NAV_RELOAD:
            return {
                ...state,
                navReload: action.navReload
            };

        default:
            return state;
    }
};

export default customizationReducer;
